import { keepPreviousData } from "@tanstack/react-query";
import { SearchTemplatesInput } from "@zapier/bff";
import { trpc } from "../trpc";

type Input = SearchTemplatesInput;

interface Options {
  enabled?: boolean;
}

export function useQuerySearchTemplates(input: Input, options?: Options) {
  const { data, isLoading, isFetching } = trpc.template.search.useQuery(
    {
      ...input,
    },
    {
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
      trpc: {
        context: {
          // Skip batching to avoid bundling this critical procedure with slower requests
          skipBatching: true,
        },
      },
      ...options,
    },
  );

  return {
    templates: data?.docs || [],
    hasNextPage: data?.hasNextPage ?? false,
    hasPrevPage: data?.hasPrevPage ?? false,
    limit: data?.limit ?? 0,
    nextPage: data?.nextPage ?? undefined,
    page: data?.page ?? 1,
    pagingCounter: data?.pagingCounter ?? 0,
    prevPage: data?.prevPage ?? undefined,
    totalDocs: data?.totalDocs ?? 0,
    totalPages: data?.totalPages ?? 0,
    isLoading,
    isFetching,
  };
}

export type Template = NonNullable<
  ReturnType<typeof useQuerySearchTemplates>["templates"]
>[number];
